import React from 'react';
import { toast as rhtToast } from 'react-hot-toast';

import { RSToast, RSToastProps } from './RSToast';

export type ToastParams = Omit<RSToastProps, 'isVisible' | 'onRequireClosing'>;

export const toast: (params: ToastParams) => void = (params) => {
  rhtToast.custom(
    (t) => (
      <RSToast
        {...params}
        isVisible={t.visible}
        onRequireClosing={() => rhtToast.dismiss(t.id)}
      />
    ),
    {
      duration: params.variant === 'error' ? Infinity : 5000,
    },
  );
};
